import {registerRoute as workbox_routing_registerRoute} from '/app/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/app/node_modules/workbox-strategies/NetworkFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/app/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/app/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/app/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {RangeRequestsPlugin as workbox_range_requests_RangeRequestsPlugin} from '/app/node_modules/workbox-range-requests/RangeRequestsPlugin.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/app/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/app/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/app/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/404.png",
    "revision": "6dde6c8b5261b92816d22390e3fd4069"
  },
  {
    "url": "/500.png",
    "revision": "ca29f732893c6145a39b0e2484d57962"
  },
  {
    "url": "/_next/app-build-manifest.json",
    "revision": "79c7d90f9daa91fd07e11f5f5e39c33a"
  },
  {
    "url": "/_next/static/7Sa1aXonl3HSTljCPjlwN/_buildManifest.js",
    "revision": "8235df113b443c223d17ecf5a8078547"
  },
  {
    "url": "/_next/static/7Sa1aXonl3HSTljCPjlwN/_ssgManifest.js",
    "revision": "b6652df95db52feb4daf4eca35380933"
  },
  {
    "url": "/_next/static/chunks/1021.fb5ab021989b51e0.js",
    "revision": "fb5ab021989b51e0"
  },
  {
    "url": "/_next/static/chunks/1371-03dad723a418c92e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/1371-03dad723a418c92e.js.map",
    "revision": "2519d3e6daa7b2c14e7cfff06b2c2742"
  },
  {
    "url": "/_next/static/chunks/1378.15494388db27b5d0.js",
    "revision": "15494388db27b5d0"
  },
  {
    "url": "/_next/static/chunks/1706.c2642055d35a1efb.js",
    "revision": "c2642055d35a1efb"
  },
  {
    "url": "/_next/static/chunks/1706.c2642055d35a1efb.js.map",
    "revision": "d0263ec41c3811a4cbb513b8ec80003c"
  },
  {
    "url": "/_next/static/chunks/1811-017df5affe606e2b.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/1811-017df5affe606e2b.js.map",
    "revision": "6a4bfa6243370d14a7bcf2fbf2531bb3"
  },
  {
    "url": "/_next/static/chunks/1860-58f20e086f92a932.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/1860-58f20e086f92a932.js.map",
    "revision": "0232852eaca60ac3089ad602afcfbe5b"
  },
  {
    "url": "/_next/static/chunks/2020.728fb52c2369dd84.js",
    "revision": "728fb52c2369dd84"
  },
  {
    "url": "/_next/static/chunks/2020.728fb52c2369dd84.js.map",
    "revision": "d6834bbb8a6094854fd3cf6c7ad0c007"
  },
  {
    "url": "/_next/static/chunks/2037.f61de3f29f372fac.js",
    "revision": "f61de3f29f372fac"
  },
  {
    "url": "/_next/static/chunks/2117-95e47c2e15ae70c0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/2117-95e47c2e15ae70c0.js.map",
    "revision": "6926d68726d35044c3dd6b9ab145cc87"
  },
  {
    "url": "/_next/static/chunks/2182-898b027906d001df.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/2182-898b027906d001df.js.map",
    "revision": "ce1cdf00aca1763fb1a85722a3149217"
  },
  {
    "url": "/_next/static/chunks/2671-342fcb7dec9ae647.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/2671-342fcb7dec9ae647.js.map",
    "revision": "96850c392d0974343e8a1d2e1256e02e"
  },
  {
    "url": "/_next/static/chunks/286.ed9a75675b1b5274.js",
    "revision": "ed9a75675b1b5274"
  },
  {
    "url": "/_next/static/chunks/2889-b383d24b6d0d4d52.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/2889-b383d24b6d0d4d52.js.map",
    "revision": "bd306f54c260c6f1157ea2fbc64522bc"
  },
  {
    "url": "/_next/static/chunks/3080.eaf9b086ce7f2edd.js",
    "revision": "eaf9b086ce7f2edd"
  },
  {
    "url": "/_next/static/chunks/3228-829160be874cdffa.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/3228-829160be874cdffa.js.map",
    "revision": "e1f90b801b768f50c5eada0a1e59ee95"
  },
  {
    "url": "/_next/static/chunks/323-43802fe12cdb2389.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/323-43802fe12cdb2389.js.map",
    "revision": "68cb4adb5a7d3b821b1cd0a4be2c78c5"
  },
  {
    "url": "/_next/static/chunks/3241.339a53ffb41af383.js",
    "revision": "339a53ffb41af383"
  },
  {
    "url": "/_next/static/chunks/3241.339a53ffb41af383.js.map",
    "revision": "768679f29760d48159fa68d63feebdab"
  },
  {
    "url": "/_next/static/chunks/3336-e06a518569071e62.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/3336-e06a518569071e62.js.map",
    "revision": "f025e9080a5e9ad80e22240e21bfd836"
  },
  {
    "url": "/_next/static/chunks/3567-fa9793af0997f00f.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/3567-fa9793af0997f00f.js.map",
    "revision": "9df9f09e2894ddf13909f5fbf2ca3934"
  },
  {
    "url": "/_next/static/chunks/3668-1c7b3a63949f9fcf.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/3668-1c7b3a63949f9fcf.js.map",
    "revision": "1b7386094c18dc5d6e95390e01fbefd1"
  },
  {
    "url": "/_next/static/chunks/3761.db745f2bdaa92af2.js",
    "revision": "db745f2bdaa92af2"
  },
  {
    "url": "/_next/static/chunks/3875.d5d1397d6813b592.js",
    "revision": "d5d1397d6813b592"
  },
  {
    "url": "/_next/static/chunks/3895.09fe059549227e0e.js",
    "revision": "09fe059549227e0e"
  },
  {
    "url": "/_next/static/chunks/4013.60d069ca9bd648ef.js",
    "revision": "60d069ca9bd648ef"
  },
  {
    "url": "/_next/static/chunks/4044.09a71f18f9314689.js",
    "revision": "09a71f18f9314689"
  },
  {
    "url": "/_next/static/chunks/4088-aa06d7310bc8a49d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/4088-aa06d7310bc8a49d.js.map",
    "revision": "20fe3b32f253ee75fb13b29cd041324e"
  },
  {
    "url": "/_next/static/chunks/425-f882486b09673eb9.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/425-f882486b09673eb9.js.map",
    "revision": "106c90aa212b43856ec0220909bb6948"
  },
  {
    "url": "/_next/static/chunks/426.e3157d26696b555e.js",
    "revision": "e3157d26696b555e"
  },
  {
    "url": "/_next/static/chunks/426.e3157d26696b555e.js.map",
    "revision": "1a3145f37e99f81e0203fcad7e732a28"
  },
  {
    "url": "/_next/static/chunks/4623.51c97a60826b82f7.js",
    "revision": "51c97a60826b82f7"
  },
  {
    "url": "/_next/static/chunks/4709.8da289c3afb59e4f.js",
    "revision": "8da289c3afb59e4f"
  },
  {
    "url": "/_next/static/chunks/4796.5835eb7bad94c9a1.js",
    "revision": "5835eb7bad94c9a1"
  },
  {
    "url": "/_next/static/chunks/4883-56adf1d6d976dce0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/4883-56adf1d6d976dce0.js.map",
    "revision": "2463f0435c531316f7079b80a16c6630"
  },
  {
    "url": "/_next/static/chunks/4979-8a06eb9521b38d71.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/4979-8a06eb9521b38d71.js.map",
    "revision": "eff0cdc6c3ab85e34401cd28818bb692"
  },
  {
    "url": "/_next/static/chunks/4e6af11a-9ac91d8c1a2c8fb2.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/4e6af11a-9ac91d8c1a2c8fb2.js.map",
    "revision": "0633543a8ad173210f7f74252e96079b"
  },
  {
    "url": "/_next/static/chunks/5005.061cb736ef07d94c.js",
    "revision": "061cb736ef07d94c"
  },
  {
    "url": "/_next/static/chunks/519-d6d973f051337bbf.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/519-d6d973f051337bbf.js.map",
    "revision": "6ca3c2c7405a9f3c68a2922a058b51c9"
  },
  {
    "url": "/_next/static/chunks/5514.34c0240b5b1d1b22.js",
    "revision": "34c0240b5b1d1b22"
  },
  {
    "url": "/_next/static/chunks/5582.183a78bae7b533fd.js",
    "revision": "183a78bae7b533fd"
  },
  {
    "url": "/_next/static/chunks/5582.183a78bae7b533fd.js.map",
    "revision": "d0c34bbdfa47eedcb5faf67c493e0f47"
  },
  {
    "url": "/_next/static/chunks/565-2212fa8005182374.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/565-2212fa8005182374.js.map",
    "revision": "de9d2e257317d5aef4638c247788c08d"
  },
  {
    "url": "/_next/static/chunks/5676.8e0659f3afbc1979.js",
    "revision": "8e0659f3afbc1979"
  },
  {
    "url": "/_next/static/chunks/5676.8e0659f3afbc1979.js.map",
    "revision": "daeae157f7bae3d0e312c89e6b11cd4d"
  },
  {
    "url": "/_next/static/chunks/568.19bc85f7a09e6966.js",
    "revision": "19bc85f7a09e6966"
  },
  {
    "url": "/_next/static/chunks/5693-91d59ba033cb6011.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/5693-91d59ba033cb6011.js.map",
    "revision": "4c280d22dfbe10bcb36bb13cab6ac491"
  },
  {
    "url": "/_next/static/chunks/605-568c26de663e9a73.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/605-568c26de663e9a73.js.map",
    "revision": "5e238996f70cf082bad8629cfc3e2e88"
  },
  {
    "url": "/_next/static/chunks/6051-1f0dd05c338c2fc3.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6051-1f0dd05c338c2fc3.js.map",
    "revision": "06e4d4e194af9b0a9b4d82867a9f4001"
  },
  {
    "url": "/_next/static/chunks/6170-648db2459b74f32d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6170-648db2459b74f32d.js.map",
    "revision": "bc8ee1d062ec3ff0899be02ece80810c"
  },
  {
    "url": "/_next/static/chunks/6213-ec5b9e8b903d48fe.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6213-ec5b9e8b903d48fe.js.map",
    "revision": "2b9ea57e9d3d7be7a850ce4946894fb3"
  },
  {
    "url": "/_next/static/chunks/6411-bd80ed88f40609e7.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6411-bd80ed88f40609e7.js.map",
    "revision": "a3c41ea410c662d4a772f8f40fe2d7a4"
  },
  {
    "url": "/_next/static/chunks/6413-93faa1b0ada41b76.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6413-93faa1b0ada41b76.js.map",
    "revision": "12ad30fdf227c0caa1029e579003dd6b"
  },
  {
    "url": "/_next/static/chunks/6458-c8b8d6a044f8dbc0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6458-c8b8d6a044f8dbc0.js.map",
    "revision": "4a8fc4a64997bc2b0ca985b3c6b94722"
  },
  {
    "url": "/_next/static/chunks/6492-ceb26ab8fc9d0041.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6492-ceb26ab8fc9d0041.js.map",
    "revision": "6978aed4a8dbe32641a189a36eaad6d2"
  },
  {
    "url": "/_next/static/chunks/6613-b02e19a1d022fa86.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6613-b02e19a1d022fa86.js.map",
    "revision": "e20bfdf93c7893d20e361084def3de9e"
  },
  {
    "url": "/_next/static/chunks/6614-4835be47a996d425.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6614-4835be47a996d425.js.map",
    "revision": "86649cfe8c97e1cf128fdbfe599ff4f9"
  },
  {
    "url": "/_next/static/chunks/6665-024ee07cff5b3314.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6665-024ee07cff5b3314.js.map",
    "revision": "96c376e3c6101ba26706447125f52425"
  },
  {
    "url": "/_next/static/chunks/6888-a90c457c7c951eee.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6888-a90c457c7c951eee.js.map",
    "revision": "7aa442a7a4d8b8098496871f42ee8aa6"
  },
  {
    "url": "/_next/static/chunks/6910-d67fedb64607d900.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/6910-d67fedb64607d900.js.map",
    "revision": "64add317f1b9a921bf1271ec328a0385"
  },
  {
    "url": "/_next/static/chunks/7082.9963d34e456da1e0.js",
    "revision": "9963d34e456da1e0"
  },
  {
    "url": "/_next/static/chunks/7375-25544beba12fcbb7.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/7375-25544beba12fcbb7.js.map",
    "revision": "1bb25064a2e70ac83a2abec129a84b6e"
  },
  {
    "url": "/_next/static/chunks/7568.de9ceaa6db87c96f.js",
    "revision": "de9ceaa6db87c96f"
  },
  {
    "url": "/_next/static/chunks/7568.de9ceaa6db87c96f.js.map",
    "revision": "03ed308b962521b19e383683fbe6c927"
  },
  {
    "url": "/_next/static/chunks/7573.4bd9f3ad14180e59.js",
    "revision": "4bd9f3ad14180e59"
  },
  {
    "url": "/_next/static/chunks/7814-7eec3c078963c690.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/7814-7eec3c078963c690.js.map",
    "revision": "1a2f7ef71fe73ef9fe41db08bfb2a12f"
  },
  {
    "url": "/_next/static/chunks/8219-6e41e24ff464ef7d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/8219-6e41e24ff464ef7d.js.map",
    "revision": "73edb0e1002be51ec8527a125bdad66e"
  },
  {
    "url": "/_next/static/chunks/828-12f1158cd2efb04a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/828-12f1158cd2efb04a.js.map",
    "revision": "b25f4cca19df997081e39f07a4029b42"
  },
  {
    "url": "/_next/static/chunks/8458-fb2b767a52cb435e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/8458-fb2b767a52cb435e.js.map",
    "revision": "5506004157b657ff6695e416b82ce771"
  },
  {
    "url": "/_next/static/chunks/8462.0883fd12cc43072a.js",
    "revision": "0883fd12cc43072a"
  },
  {
    "url": "/_next/static/chunks/8462.0883fd12cc43072a.js.map",
    "revision": "b8bebc98bffe6b1dceec0b387db22b29"
  },
  {
    "url": "/_next/static/chunks/8488.7a063fca1cecaa22.js",
    "revision": "7a063fca1cecaa22"
  },
  {
    "url": "/_next/static/chunks/8488.7a063fca1cecaa22.js.map",
    "revision": "ec26beab6a9076ff64daff3c67d01647"
  },
  {
    "url": "/_next/static/chunks/8569.4ba2adc976ee01fe.js",
    "revision": "4ba2adc976ee01fe"
  },
  {
    "url": "/_next/static/chunks/8569.4ba2adc976ee01fe.js.map",
    "revision": "670c146cd5de517ebe28792bacb72c89"
  },
  {
    "url": "/_next/static/chunks/878-7df723cce5a7402d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/878-7df723cce5a7402d.js.map",
    "revision": "c777c157d45dd88736efb02ff6750108"
  },
  {
    "url": "/_next/static/chunks/8810-6390c247348fef7d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/8810-6390c247348fef7d.js.map",
    "revision": "bc319bd45355b1f7fced564106ce82c3"
  },
  {
    "url": "/_next/static/chunks/8850.e53df88b2deec2b2.js",
    "revision": "e53df88b2deec2b2"
  },
  {
    "url": "/_next/static/chunks/911-dab941cf87f6400d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/911-dab941cf87f6400d.js.map",
    "revision": "b2423e7ff62466ae253b1f3e28616779"
  },
  {
    "url": "/_next/static/chunks/9233.2100e2db4c95c57d.js",
    "revision": "2100e2db4c95c57d"
  },
  {
    "url": "/_next/static/chunks/9262-6524edc39ccbb771.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/9262-6524edc39ccbb771.js.map",
    "revision": "cbf7ef8d04a1c416f939281d50c865bb"
  },
  {
    "url": "/_next/static/chunks/9326.0296b74766f4a3fa.js",
    "revision": "0296b74766f4a3fa"
  },
  {
    "url": "/_next/static/chunks/9349-6190fc1441ad9c7f.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/9349-6190fc1441ad9c7f.js.map",
    "revision": "fcad37d13d31d8fd776f1e5a9ff77019"
  },
  {
    "url": "/_next/static/chunks/9652-383704fa32ea3cff.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/9652-383704fa32ea3cff.js.map",
    "revision": "80280ee80ba252c541cdb10f22020fd1"
  },
  {
    "url": "/_next/static/chunks/9685.286a17df57db0d3a.js",
    "revision": "286a17df57db0d3a"
  },
  {
    "url": "/_next/static/chunks/9828-7da34381ce763ae8.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/9828-7da34381ce763ae8.js.map",
    "revision": "99177e8529cbfe243e22d1a7d8279b08"
  },
  {
    "url": "/_next/static/chunks/9982-ecd1d28b0c9a9607.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/9982-ecd1d28b0c9a9607.js.map",
    "revision": "333769a1812f59ca947413b4b53a603a"
  },
  {
    "url": "/_next/static/chunks/aaea2bcf-e4b10cabbe45ce21.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/aaea2bcf-e4b10cabbe45ce21.js.map",
    "revision": "01572a2e3efe4e144ced0af9c96f223c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/basket-b2b/page-f034e07e697f9785.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/basket-b2b/page-f034e07e697f9785.js.map",
    "revision": "964ceb4ab7b9a95604a57cf7c3c71471"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/basket/page-81a9a26d36d9a63e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/basket/page-81a9a26d36d9a63e.js.map",
    "revision": "99d5c3add03e17835a5f4d122c9bd550"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/layout-1c33bb283a55c37e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/layout-1c33bb283a55c37e.js.map",
    "revision": "9c1ae97f485d4e5a8775d8e69bcb0c1d"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/orders/checkout/page-1c904c1fb3874d67.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(payment)/orders/checkout/page-1c904c1fb3874d67.js.map",
    "revision": "9b8b680339b879af4ddb62e4ec651365"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/%5B...not_found%5D/page-73b4988210c75fb9.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/bize-ulasin/page-21355fe522255696.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/bize-ulasin/page-21355fe522255696.js.map",
    "revision": "4d734b7f88b54562cd82ac4326693918"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/hakkimizda/page-b38308194570aeed.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/hakkimizda/page-b38308194570aeed.js.map",
    "revision": "e87dd54ad2d96d3ff4ec2b8f67b701f3"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/magazalarimiz/page-66c9f7c5f598651d.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/magazalarimiz/page-66c9f7c5f598651d.js.map",
    "revision": "97fe318f30e9a32cf027ed769f0be7b3"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/markalar/page-87bc203510835487.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/markalar/page-87bc203510835487.js.map",
    "revision": "3a6fc50c8d7bb4953600f63bfc6474ae"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/sikca-sorulan-sorular/page-b8ff6e2b1488ac92.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/(flatpages)/sikca-sorulan-sorular/page-b8ff6e2b1488ac92.js.map",
    "revision": "206332a41e027b44b129382d5771f107"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/address/form/page-36e8a837f24357c5.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/address/form/page-36e8a837f24357c5.js.map",
    "revision": "729c053c988044d4ffc58676fd5f08d1"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/address/page-3212a38f98335410.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/address/page-3212a38f98335410.js.map",
    "revision": "def4a2f2a5935bd7e5c47817e25462e7"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/change-email/page-c358e2ae3d170a76.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/change-email/page-c358e2ae3d170a76.js.map",
    "revision": "b5525f42a536c9efe1483c1abc928c91"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/change-password/page-af901a8f62e4a0b3.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/change-password/page-af901a8f62e4a0b3.js.map",
    "revision": "49c75ce94a290b297993df5fdfae47cb"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/collections/%5Bpk%5D/page-ef112ca0d08e559a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/collections/%5Bpk%5D/page-ef112ca0d08e559a.js.map",
    "revision": "6e2ff29c6bdbead8048dda06f6b4d4de"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/collections/page-6f4c3709ef55239f.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/collections/page-6f4c3709ef55239f.js.map",
    "revision": "aef36b85d5af393826d76d18e631d802"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/coupons/page-89f68471b67ee327.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/coupons/page-89f68471b67ee327.js.map",
    "revision": "22fb111a0b404b2d01ff898bc6f7fd03"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/email-verification/page-3258473e58c35051.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/email-verification/page-3258473e58c35051.js.map",
    "revision": "e6cf4d65b1b3664c208555bf123106bd"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/faq/page-04247054e455647a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/faq/page-04247054e455647a.js.map",
    "revision": "38d0226b28222007bbc74b3c6fc48384"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/favourite-products/page-eb5edc3f2f88be91.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/favourite-products/page-eb5edc3f2f88be91.js.map",
    "revision": "9ff064554bf70da4384b7059bf191b16"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/layout-7634f5f9dcfed5db.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/layout-7634f5f9dcfed5db.js.map",
    "revision": "5709f0635e342a50e9ae777c2c1e557d"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/my-quotations/page-1b1165d64ab6477c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/my-quotations/page-1b1165d64ab6477c.js.map",
    "revision": "3540447bed675256d259031f09ca375a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/notification-settings/page-ed55fde53caba72b.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/notification-settings/page-ed55fde53caba72b.js.map",
    "revision": "b32712e51c884a403829065c6b756acb"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/orders/%5Bid%5D/layout-045ab9d78afba7c1.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/orders/%5Bid%5D/page-57507f20821fc0b3.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/orders/%5Bid%5D/page-57507f20821fc0b3.js.map",
    "revision": "72d10401741d74bf7c55348b4de6929a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/orders/page-e407645ca69e98f0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/orders/page-e407645ca69e98f0.js.map",
    "revision": "d35737ca8bc646f76af46fa07791c1e1"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/page-93e9f7805257eb5e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/page-93e9f7805257eb5e.js.map",
    "revision": "7cf3410922d9180d2901ed5f785a4926"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/profile/page-131185fae8667415.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/account/profile/page-131185fae8667415.js.map",
    "revision": "acf55ace58adda7fa3749c82e7ea49bc"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/detail/page-2eb490bcd821f052.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/detail/page-2eb490bcd821f052.js.map",
    "revision": "9d1e870cba488dc9e5fad7654756e026"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/layout-54b80023b9337ceb.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/layout-54b80023b9337ceb.js.map",
    "revision": "5f59f7f6b1017ae2e6c59d83a7ced546"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/page-dde86d18dc482f6c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/anonymous-tracking/page-dde86d18dc482f6c.js.map",
    "revision": "d74e1cd87da0ffd2ec70d8d9c52d9e97"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/auth/oauth-login/page-02501be7bfd8b81e.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/auth/oauth-login/page-02501be7bfd8b81e.js.map",
    "revision": "702e135e6e56229589422481f120aadf"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/auth/page-30e829fff9398161.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/auth/page-30e829fff9398161.js.map",
    "revision": "5944e063f413d8fe00aa3d1ddcc804c0"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/category/%5Bpk%5D/loading-2546c16fae6cfe54.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/category/%5Bpk%5D/page-a27523a7b6b5ff3a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/category/%5Bpk%5D/page-a27523a7b6b5ff3a.js.map",
    "revision": "3b17d6749ee856412bac1d5a397f96b1"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/flat-page/%5Bpk%5D/loading-27b5a0f592e0db0a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/flat-page/%5Bpk%5D/loading-27b5a0f592e0db0a.js.map",
    "revision": "9ee4982ca6c3311593027a4f1fdadcf6"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/flat-page/%5Bpk%5D/page-466bf5de8c97be52.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/flat-page/%5Bpk%5D/page-466bf5de8c97be52.js.map",
    "revision": "1aac744800a173a5c5bcd358e524acca"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/forms/%5Bpk%5D/generate/page-dc72f01c9a4da7cc.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/forms/%5Bpk%5D/generate/page-dc72f01c9a4da7cc.js.map",
    "revision": "c05da0838bd30f33cf3e5c316c76e85f"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/group-product/%5Bpk%5D/loading-86c03872ef75f7a0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/group-product/%5Bpk%5D/loading-86c03872ef75f7a0.js.map",
    "revision": "c7c604386e820c5b4948074a908b46e5"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/group-product/%5Bpk%5D/page-6427bcdddb211e20.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/group-product/%5Bpk%5D/page-6427bcdddb211e20.js.map",
    "revision": "bf13b0b9b472d3f83391bc7fd4247984"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/landing-page/%5Bpk%5D/loading-cfc7ef5870dd843c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/landing-page/%5Bpk%5D/loading-cfc7ef5870dd843c.js.map",
    "revision": "e0702c188472de64d7d26bd2667bf9b0"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/landing-page/%5Bpk%5D/page-fea7b39d88868fd6.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/landing-page/%5Bpk%5D/page-fea7b39d88868fd6.js.map",
    "revision": "8f0ea3b416d3c942b6234e50c5265b2c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/layout-8440dfcbd0fd127f.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/layout-8440dfcbd0fd127f.js.map",
    "revision": "4b5f4c212f278fd45c2a442df19eacce"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/list/loading-49a8bf7e5b038af4.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/list/page-459fce4cd4b6cb25.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/list/page-459fce4cd4b6cb25.js.map",
    "revision": "7d4c0d1ba9708e767385ecc7cfd0c4d5"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/orders/completed/%5Btoken%5D/layout-322545bfe3f46123.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/orders/completed/%5Btoken%5D/page-3715e493c2b2f401.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/orders/completed/%5Btoken%5D/page-3715e493c2b2f401.js.map",
    "revision": "fa554825c5596367325ecac33978a61a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/page-8cbbba300400b001.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/page-8cbbba300400b001.js.map",
    "revision": "b0ed5b0a879ab0f9627cff9c9937ed9b"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/product/%5Bpk%5D/loading-3f050e8032dd7b63.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/product/%5Bpk%5D/page-da2842453b6b936c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/product/%5Bpk%5D/page-da2842453b6b936c.js.map",
    "revision": "bee0c468b2e6d71d1a068b70a42fc4d7"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/pz-not-found/page-20f8006fc1296b2a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/pz-not-found/page-20f8006fc1296b2a.js.map",
    "revision": "29c5aed82f240b9ee9aa157c9f2bdb5c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/special-page/%5Bpk%5D/loading-06d7c9fd8bc0c799.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/special-page/%5Bpk%5D/page-9e24b0cdea76a7ee.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/special-page/%5Bpk%5D/page-9e24b0cdea76a7ee.js.map",
    "revision": "54ae4877de994c86be29eaf5fb55ed09"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/styleguide/page-d60c0af54596e916.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/styleguide/page-d60c0af54596e916.js.map",
    "revision": "7f3258c156f30b4d4c9a9a52c95aa024"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/email-set-primary/%5B%5B...id%5D%5D/page-c6de6681ae8d2d6a.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/email-set-primary/%5B%5B...id%5D%5D/page-c6de6681ae8d2d6a.js.map",
    "revision": "37f2f2d21f67669f6b164e029be5e063"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/password/reset/page-dd1fd421fff00435.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/password/reset/page-dd1fd421fff00435.js.map",
    "revision": "b9fff08b4729e6ad0318e6f356094541"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/registration/account-confirm-email/%5B%5B...id%5D%5D/page-316a2f25f30be9a2.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/registration/account-confirm-email/%5B%5B...id%5D%5D/page-316a2f25f30be9a2.js.map",
    "revision": "0ac83cd44d46ddc5c20412ddbb29ea4a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/reset/%5B%5B...id%5D%5D/page-e84f999da691a6d3.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/(root)/users/reset/%5B%5B...id%5D%5D/page-e84f999da691a6d3.js.map",
    "revision": "b0a071deda1384daf58a092f95763ffd"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/%5Bid%5D/page-4570ed03c79f33dc.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/%5Bid%5D/page-4570ed03c79f33dc.js.map",
    "revision": "6b4a8e0c084f9e7419154d50b41f014c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/layout-ab7154d12f09c5fb.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/layout-ab7154d12f09c5fb.js.map",
    "revision": "36ea0f97f694b9c204445dae0c56b2ae"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/page-cad25dcb0d41a4c1.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/blog/page-cad25dcb0d41a4c1.js.map",
    "revision": "98a8526f5dd0fc3ce2bac6b9ea755a7b"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/error-9426ca01e9e6fa55.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/error-9426ca01e9e6fa55.js.map",
    "revision": "0fa58b4c357debf131d0d1b3b5894442"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/layout-930cff17c10c511c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/layout-930cff17c10c511c.js.map",
    "revision": "cb694acac32c9b7db14aee0b700a4171"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/not-found-06309fd431103cf7.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/not-found-06309fd431103cf7.js.map",
    "revision": "7bc1b7365716c0d6a7e0ede8b045ed69"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/template-56e178924ec15f49.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/template-56e178924ec15f49.js.map",
    "revision": "aced8f00d2981e0c1b52fb7a465dcd1f"
  },
  {
    "url": "/_next/static/chunks/app/_not-found/page-56ba3885ea3e74be.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/app/_not-found/page-56ba3885ea3e74be.js.map",
    "revision": "77c166aaa5e2dc669ef510bf182ddca8"
  },
  {
    "url": "/_next/static/chunks/fd9d1056-4668312ba6abb0bb.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/fd9d1056-4668312ba6abb0bb.js.map",
    "revision": "e3692962b7e12be9a3c3df48416739a7"
  },
  {
    "url": "/_next/static/chunks/framework-5ecab0c61b5051c5.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/framework-5ecab0c61b5051c5.js.map",
    "revision": "6cfb81e09b02ac85632f8fd43130e978"
  },
  {
    "url": "/_next/static/chunks/main-7c6c880bba4150e1.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/main-7c6c880bba4150e1.js.map",
    "revision": "a718e8d14ceecf65a087062ca07e5ff0"
  },
  {
    "url": "/_next/static/chunks/main-app-fb757dbf2494d41f.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/main-app-fb757dbf2494d41f.js.map",
    "revision": "3cbecc23778d6c217e731ece77f62e2b"
  },
  {
    "url": "/_next/static/chunks/pages/_app-9f5760457b3fbb4c.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/pages/_app-9f5760457b3fbb4c.js.map",
    "revision": "96eded7044be05c8a942077d2ff2b564"
  },
  {
    "url": "/_next/static/chunks/pages/_error-bb54a79383b31438.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/pages/_error-bb54a79383b31438.js.map",
    "revision": "a9d8c6d90cebec6c0a3b02e6d64fcc1a"
  },
  {
    "url": "/_next/static/chunks/polyfills-42372ed130431b0a.js",
    "revision": "846118c33b2c0e922d7b3a7676f81f6f"
  },
  {
    "url": "/_next/static/chunks/webpack-a00548049918d4f0.js",
    "revision": "7Sa1aXonl3HSTljCPjlwN"
  },
  {
    "url": "/_next/static/chunks/webpack-a00548049918d4f0.js.map",
    "revision": "d68566401389c65f025fe8b682c47fab"
  },
  {
    "url": "/_next/static/css/551f9bc71cac4ae4.css",
    "revision": "551f9bc71cac4ae4"
  },
  {
    "url": "/_next/static/css/551f9bc71cac4ae4.css.map",
    "revision": "3050b48c59fff8c3afa8296842d3affe"
  },
  {
    "url": "/_next/static/css/669f9c8ce34845b7.css",
    "revision": "669f9c8ce34845b7"
  },
  {
    "url": "/_next/static/css/669f9c8ce34845b7.css.map",
    "revision": "8b97c3530e82a3d675bc811962918da8"
  },
  {
    "url": "/_next/static/css/6707668153597423.css",
    "revision": "6707668153597423"
  },
  {
    "url": "/_next/static/css/6707668153597423.css.map",
    "revision": "e0d190c9adf96f880613bb9a82bc9280"
  },
  {
    "url": "/_next/static/css/697cc8f688a5d821.css",
    "revision": "697cc8f688a5d821"
  },
  {
    "url": "/_next/static/css/697cc8f688a5d821.css.map",
    "revision": "b18aaf0f396ee1a0cfabc3718718cf23"
  },
  {
    "url": "/_next/static/css/88a4d3ee4b76bf92.css",
    "revision": "88a4d3ee4b76bf92"
  },
  {
    "url": "/_next/static/css/88a4d3ee4b76bf92.css.map",
    "revision": "5f4b23a7c1ae857adf8a01e171558b91"
  },
  {
    "url": "/_next/static/css/8ea816983a17b340.css",
    "revision": "8ea816983a17b340"
  },
  {
    "url": "/_next/static/css/8ea816983a17b340.css.map",
    "revision": "3ff8273d1a9265df77b342f79badd74e"
  },
  {
    "url": "/_next/static/media/0a86735c6520d94f-s.woff2",
    "revision": "94df5f5371c15d43ad8c4420affa4ec2"
  },
  {
    "url": "/_next/static/media/32c80fb7588b7a2e-s.woff2",
    "revision": "12840a0de41148365a96c14aa390ec25"
  },
  {
    "url": "/_next/static/media/5b25d60b4670300e-s.p.woff2",
    "revision": "fb299d85c631402fd293db3b132c48ad"
  },
  {
    "url": "/_next/static/media/60181e10ad16e354-s.woff2",
    "revision": "18564d43c7cb9f93f6c1d5a27cdc8188"
  },
  {
    "url": "/_next/static/media/99e31c27a1524300-s.woff2",
    "revision": "4de858e8208d82b4da29e153281b6777"
  },
  {
    "url": "/_next/static/media/ajax-loader.0b80f665.gif",
    "revision": "0b80f665"
  },
  {
    "url": "/_next/static/media/c1b11e140b58cf5a-s.woff2",
    "revision": "368f3e99ee207a4a2e2584eba7d3c82f"
  },
  {
    "url": "/_next/static/media/pz-icon.3182e4e9.woff",
    "revision": "3182e4e9"
  },
  {
    "url": "/_next/static/media/pz-icon.5a4cbbd4.eot",
    "revision": "5a4cbbd4"
  },
  {
    "url": "/_next/static/media/pz-icon.9ff10bb3.woff2",
    "revision": "9ff10bb3"
  },
  {
    "url": "/_next/static/media/pz-icon.bd9db32e.svg",
    "revision": "bd9db32e"
  },
  {
    "url": "/_next/static/media/pz-icon.dd4050b9.ttf",
    "revision": "dd4050b9"
  },
  {
    "url": "/_next/static/media/slick.25572f22.eot",
    "revision": "25572f22"
  },
  {
    "url": "/_next/static/media/slick.653a4cbb.woff",
    "revision": "653a4cbb"
  },
  {
    "url": "/_next/static/media/slick.6aa1ee46.ttf",
    "revision": "6aa1ee46"
  },
  {
    "url": "/_next/static/media/slick.f895cfdf.svg",
    "revision": "f895cfdf"
  },
  {
    "url": "/apple-splash-1125-2436.jpg",
    "revision": "24075b75e47b1b7785f756818f7fddf7"
  },
  {
    "url": "/apple-splash-1136-640.jpg",
    "revision": "273640b134687b9479bcb0f1a804095f"
  },
  {
    "url": "/apple-splash-1170-2532.jpg",
    "revision": "64d16884738a287b9cc1c360a8f41707"
  },
  {
    "url": "/apple-splash-1242-2208.jpg",
    "revision": "d6fa35c56ca7a6777158600888496883"
  },
  {
    "url": "/apple-splash-1242-2688.jpg",
    "revision": "3f640495c22783d8f5bc4d91012385ed"
  },
  {
    "url": "/apple-splash-1284-2778.jpg",
    "revision": "e8fe6af17bdd01f2a84a362576aefc75"
  },
  {
    "url": "/apple-splash-1334-750.jpg",
    "revision": "be002ee88d7a75f993a7fe45bbd604a8"
  },
  {
    "url": "/apple-splash-1536-2048.jpg",
    "revision": "64e34c3a3c866568e8eb60a69ee09e26"
  },
  {
    "url": "/apple-splash-1620-2160.jpg",
    "revision": "77c2607eda54644bc2bb9e1d3d530f53"
  },
  {
    "url": "/apple-splash-1668-2224.jpg",
    "revision": "88838ea4f4b3632eb810f2d3e305680a"
  },
  {
    "url": "/apple-splash-1668-2388.jpg",
    "revision": "e4d64176b45ffb3c9a88dca44dff7d0c"
  },
  {
    "url": "/apple-splash-1792-828.jpg",
    "revision": "fe2abd8177c0b5a386296efe69073081"
  },
  {
    "url": "/apple-splash-2048-1536.jpg",
    "revision": "f7898375d52dc8416353f0638f411a04"
  },
  {
    "url": "/apple-splash-2048-2732.jpg",
    "revision": "d39019c1d7851e199dd3113f9a29ba17"
  },
  {
    "url": "/apple-splash-2160-1620.jpg",
    "revision": "86d7d136ce221258e0f236ba9303d990"
  },
  {
    "url": "/apple-splash-2208-1242.jpg",
    "revision": "70e79877e659e555edd6a11359d6163b"
  },
  {
    "url": "/apple-splash-2224-1668.jpg",
    "revision": "8083a73241d20419ea5d21f4866241dd"
  },
  {
    "url": "/apple-splash-2388-1668.jpg",
    "revision": "ad3d920aec78c50b1565df4dc7bff214"
  },
  {
    "url": "/apple-splash-2436-1125.jpg",
    "revision": "89cc74b294304f36da8233cae00f53b3"
  },
  {
    "url": "/apple-splash-2532-1170.jpg",
    "revision": "8e755b86a59fa13640b105bb67353f71"
  },
  {
    "url": "/apple-splash-2688-1242.jpg",
    "revision": "bdbb924f4c75254a4e63ef11091beaff"
  },
  {
    "url": "/apple-splash-2732-2048.jpg",
    "revision": "5999f56c7d0414f81d83ded6bf3843d0"
  },
  {
    "url": "/apple-splash-2778-1284.jpg",
    "revision": "4149990f5a3361f02801f76a73c58bae"
  },
  {
    "url": "/apple-splash-640-1136.jpg",
    "revision": "f7b7782a28663ce2824d1b11fbb95e8c"
  },
  {
    "url": "/apple-splash-750-1334.jpg",
    "revision": "c920aed25d2acca73bed61abbe8e4206"
  },
  {
    "url": "/apple-splash-828-1792.jpg",
    "revision": "2c71edb2bcae1d318a1a4c299c1e655c"
  },
  {
    "url": "/apple-touch-icon-152x152.png",
    "revision": "8bcde4599f4a92452748665fd08d29be"
  },
  {
    "url": "/apple-touch-icon-167x167.png",
    "revision": "97b216a5907c1bc5a9817905efe32757"
  },
  {
    "url": "/apple-touch-icon-180x180.png",
    "revision": "8768852b7915081f96aaa917fc60d619"
  },
  {
    "url": "/apple-touch-icon.png",
    "revision": "328945e66ccfbbf41c72d42dfbcc80f9"
  },
  {
    "url": "/apple.svg",
    "revision": "caaa8f066406c0621343f02c150fb668"
  },
  {
    "url": "/cvv.jpg",
    "revision": "46f6c00e0998c358dbc58c2af26d1dfd"
  },
  {
    "url": "/facebook.svg",
    "revision": "ad1133eec36b8858ae4f8331c3b60b44"
  },
  {
    "url": "/favicon.png",
    "revision": "703f68da1193588e4bcd33fd83d4880a"
  },
  {
    "url": "/favicon.webp",
    "revision": "4540a3a2836c61ee75ab7047b33da40c"
  },
  {
    "url": "/google.svg",
    "revision": "bf2d317a3a208ca877eb7d7d655636a9"
  },
  {
    "url": "/icon-192x192.png",
    "revision": "a8fa226bbab8f87800ba725be311376a"
  },
  {
    "url": "/icon-256x256.png",
    "revision": "b2dd8ec7e696ea1952a8cba529d6ba50"
  },
  {
    "url": "/icon-384x384.png",
    "revision": "fae45bd6f4abf99457062d87b04d2c5f"
  },
  {
    "url": "/icon-512x512.png",
    "revision": "c813535f8936f031ae2f9f0693206433"
  },
  {
    "url": "/icon-sprite.svg",
    "revision": "d4c81c1d2b0154c0b52b44d1940cd8b0"
  },
  {
    "url": "/iyzico.png",
    "revision": "db886100b8120afb138cbc71181a77f5"
  },
  {
    "url": "/locales/en/account.json",
    "revision": "6c35bb9975ac57a6aa38f9e69d81b589"
  },
  {
    "url": "/locales/en/auth.json",
    "revision": "a1cd2c1a2f7e03b43a1c55bd767a5fa6"
  },
  {
    "url": "/locales/en/basket.json",
    "revision": "6407213100519caad73e7efa120b4249"
  },
  {
    "url": "/locales/en/category.json",
    "revision": "1325110f90bef24b6096a89d6ebba7b3"
  },
  {
    "url": "/locales/en/checkout.json",
    "revision": "305f94aef2fad44a38ac4f9b07e61358"
  },
  {
    "url": "/locales/en/common.json",
    "revision": "c44b89b4a374bf7f0d546487e19cd1dc"
  },
  {
    "url": "/locales/en/flatpages.json",
    "revision": "9054f57e41081fbc8d834121cea03ea1"
  },
  {
    "url": "/locales/en/forgot_password.json",
    "revision": "5971748b034d622c348cb27ab9adf2c4"
  },
  {
    "url": "/locales/en/form.json",
    "revision": "96c46f5657057f37781f780c22947276"
  },
  {
    "url": "/locales/en/index.json",
    "revision": "c869ecae2026fead271fcc9e32bfaeef"
  },
  {
    "url": "/locales/en/not_found.json",
    "revision": "10151057cc71e30f3681b27d0ae38728"
  },
  {
    "url": "/locales/en/product.json",
    "revision": "aa02c92a6818694d01a40d9a05a81f9f"
  },
  {
    "url": "/locales/tr/account.json",
    "revision": "ee9f568cfee6cc00fb745ee62499d8d5"
  },
  {
    "url": "/locales/tr/auth.json",
    "revision": "c2d99b1cc139c1d022ab2d2bf67ca0f7"
  },
  {
    "url": "/locales/tr/basket.json",
    "revision": "f19952df23abc6014e0c51f4c731cda5"
  },
  {
    "url": "/locales/tr/category.json",
    "revision": "1f91b095e827d1bec327a577d107ea1d"
  },
  {
    "url": "/locales/tr/checkout.json",
    "revision": "aa07cf8dbd696df6c7252d7be39d3928"
  },
  {
    "url": "/locales/tr/common.json",
    "revision": "933833b7b013d91d43221c1f94238dba"
  },
  {
    "url": "/locales/tr/flatpages.json",
    "revision": "1c6ee7d82b6c41d0239d7e1cc1620612"
  },
  {
    "url": "/locales/tr/forgot_password.json",
    "revision": "eeb605e89de0055953c42ff53a96ec06"
  },
  {
    "url": "/locales/tr/form.json",
    "revision": "816cf71084f501ef0c696d045da0c5e6"
  },
  {
    "url": "/locales/tr/index.json",
    "revision": "c43121c9de949e585aae6a91660c6ea5"
  },
  {
    "url": "/locales/tr/not_found.json",
    "revision": "ba80697e218a37d3602539b5ab36b5b8"
  },
  {
    "url": "/locales/tr/product.json",
    "revision": "4bece0903a887c58e2da5f723e95e465"
  },
  {
    "url": "/logo.svg",
    "revision": "269b8d6f64b61a4ebb57e5c823fea48f"
  },
  {
    "url": "/logo_white.svg",
    "revision": "7c6fc2277874cfe8c7e8273b9ca406cc"
  },
  {
    "url": "/manifest.json",
    "revision": "a32553ee42df83164a93d4445d175fe4"
  },
  {
    "url": "/map-pin.svg",
    "revision": "ac079b09a5ec7b80c9c675a57f558043"
  },
  {
    "url": "/mastercard.png",
    "revision": "6edab6d626c5f041235585767ecfa221"
  },
  {
    "url": "/mastersecure.png",
    "revision": "5f4f1a282759c6ed3938bde622de3898"
  },
  {
    "url": "/mfs-client.min.js",
    "revision": "9409aeb32a0f7b8579de9da17d3fcb01"
  },
  {
    "url": "/noimage.jpg",
    "revision": "82460b58ae6d0db84b93aa4b1f7308b1"
  },
  {
    "url": "/payments.png",
    "revision": "e7d7fe98365f56606ff23582ed3114d5"
  },
  {
    "url": "/safari-pinned-tab.svg",
    "revision": "33a1d9ffebe6a89ebf180c76a6a40110"
  },
  {
    "url": "/ssl-secure.png",
    "revision": "af4e0de8549681d1ee5df29a6be959a0"
  },
  {
    "url": "/vbv.png",
    "revision": "9cc5bb174d3b6bf92d349f04b3ba7ebf"
  },
  {
    "url": "/visa.png",
    "revision": "687df134aa36fd286c8be449df2e8dc3"
  },
  {
    "url": "/zepto.min.js",
    "revision": "50a4556b0089cfa1cb61e88ea23bbcce"
  }
], {
  "ignoreURLParametersMatching": []
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ request, response, event, state }) => { if (response && response.type === 'opaqueredirect') { return new Response(response.body, { status: 200, statusText: 'OK', headers: response.headers }) } return response } }] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:gstatic)\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts-webfonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:googleapis)\.com\/.*/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"google-fonts-stylesheets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:eot|otf|ttc|ttf|woff|woff2|font.css)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-font-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:jpg|jpeg|gif|png|svg|ico|webp)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-image-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/image\?url=.+$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-image", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp3|wav|ogg)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-audio-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp4)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-video-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:js)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-js-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|less)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-style-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/data\/.+\/.+\.json$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-data", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:json|xml|csv)$/i, new workbox_strategies_NetworkFirst({ "cacheName":"static-data-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      // Exclude /api/auth/callback/* to fix OAuth workflow in Safari without impact other environment
      // Above route is default for next-auth, you may need to change it if your OAuth workflow has a different callback route
      // Issue: https://github.com/shadowwalker/next-pwa/issues/131#issuecomment-821894809
      if (pathname.startsWith('/api/auth/')) return false
      if (pathname.startsWith('/api/')) return true
      return false
    }, new workbox_strategies_NetworkFirst({ "cacheName":"apis","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 16, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      if (pathname.startsWith('/api/')) return false
      return true
    }, new workbox_strategies_NetworkFirst({ "cacheName":"others","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      return !isSameOrigin
    }, new workbox_strategies_NetworkFirst({ "cacheName":"cross-origin","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 3600 })] }), 'GET');




